import { ActivatedRoute, Router } from '@angular/router';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ConfigurationService } from '../services';
import { ServerMetadataService } from '../services/server-metadata.service';
import { AuthenticationComponent } from '../authentication/authentication.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { initApplicationSelector } from '../store/Application/ApplicationSelector';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../store/Application/ApplicationReducer';
import { ServerConfig } from '../models/ServerConfig';
import { EnvironmentType } from '../models/EnvironmentType';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
})
export class LandingComponent implements OnInit, AfterViewInit {
  selectedIndex = 1;
  isCollapsed = true;
  isRegisterEnabled: boolean;

  @ViewChild('vid', { static: true }) vidEl: ElementRef;
  video: HTMLVideoElement;

  @ViewChild('top')
  top: ElementRef;

  config: ServerConfig;
  EnvironmentType = EnvironmentType;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly configurationService: ConfigurationService,
    private readonly router: Router,
    private readonly applicationStore: Store<ApplicationState>,
    private readonly serverMetadataService: ServerMetadataService,
    private readonly modalService: BsModalService,
  ) {
    if (this.isRegisterEnabled) {
      this.activatedRoute.url.subscribe((url) => {
        if (url.toString().includes('login')) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex = 1;
        }
      });
    } else {
      this.router.navigateByUrl('login');
    }
  }

  ngOnInit() {
    this.playVideo();
    this.applicationStore
      .select(initApplicationSelector)
      .subscribe((config) => {
        this.config = config;
        this.isRegisterEnabled = config.isRegistrationEnabled;
      });
    if (ServerMetadataService.openLoginAfterLoad) {
      this.openAuthentication('Login');
      ServerMetadataService.openLoginAfterLoad = false;
    }
  }

  playVideo() {
    this.video = this.vidEl.nativeElement;

    if (window.matchMedia('(prefers-reduced-motion)').matches) {
      this.vidEl.nativeElement.removeAttribute('autoplay');
      this.vidEl.nativeElement.play();
    }
  }

  openAuthentication(from) {
    const initialState = {
      page: from,
      isRegisterEnabled: this.isRegisterEnabled,
    };

    this.modalService.show(AuthenticationComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      keyboard: true,
      class: 'auth-modal',
      initialState,
    });
  }

  ngAfterViewInit(): void {
    console.warn("i'm useless :)");
  }
}
